import { useCallback } from 'react';

import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

export interface YearSelectProps {
  /**
   * Invoked when a new year is selected.
   */
  onChange: (year: number) => void;
  /**
   * An array of numeric strings indicating the selectable years.
   */
  selectableYears: number[];
  /**
   * The currently selected year.
   */
  value: number;
}

export const YearSelect = ({ onChange, selectableYears, value }: YearSelectProps) => {
  const handleOnChange = useCallback((evt: SelectChangeEvent) => onChange(parseInt(evt.target.value)), [onChange]);

  return (
    <Select size="small" value={value.toString()} onChange={handleOnChange} disabled={selectableYears.length <= 1}>
      {selectableYears.map((year) => (
        <MenuItem key={year} value={year}>
          {year}
        </MenuItem>
      ))}
    </Select>
  );
};
